module.exports = __webpack_public_path__ + "img/9788973816965.e065e0b0.jpg";